var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#a5a5a5",
    cx: 23.9602,
    cy: 23.95432,
    id: "svg_6",
    rx: 23.77017,
    ry: 23.80988
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m31.52669,27.79108l0,2.5618c0,0.7073 -0.67522,1.2809 -1.50782,1.2809l-12.06257,0c-0.8326,0 -1.50782,-0.5736 -1.50782,-1.2809l0,-2.5618c0,-0.7073 -0.67522,-1.2809 -1.50782,-1.2809s-1.50782,0.5736 -1.50782,1.2809l0,2.5618c0,2.12229 2.0252,3.8427 4.52347,3.8427l12.06257,0c2.49827,0 4.52347,-1.7204 4.52347,-3.8427l0,-2.5618c0,-0.7073 -0.67522,-1.2809 -1.50782,-1.2809s-1.50782,0.5724 -1.50782,1.2809l-0.00001,0zm-8.604,-13.71462l-6.03129,5.1236c-0.58947,0.50075 -0.58852,1.31132 0,1.81127c0.58899,0.50035 1.54316,0.50035 2.13216,0l3.45621,-2.93506l0,8.43392c0,0.7081 0.67428,1.2809 1.50782,1.2809s1.50782,-0.5728 1.50782,-1.2809l0,-8.43392l3.45762,2.93726c0.58899,0.50035 1.54316,0.50035 2.13216,0s0.58899,-1.31092 0,-1.81127l-6.03129,-5.1236c-0.59041,-0.50255 -1.54222,-0.50255 -2.13121,-0.0022l0,0.00001z",
    id: "svg_3",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.69a8ef09cad8afb021487d7a82b8a1c9.svg";
export { ForwardRef as ReactComponent };